"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgHelp(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zm1 11h-2l.13 2h1.675zm-.982-7C10.676 4 9.715 4.56 9 5.376l1.133 1.286c.567-.586 1.159-.879 1.849-.879.714 0 1.133.332 1.133.905v.025c0 .676-.604 1.096-2.156 1.16l-.062.063.284 2.064h1.256l.136-.777C13.916 8.943 15 8.28 15 6.663v-.026C15 4.943 13.793 4 12.018 4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Help')(SvgHelp);
//# sourceMappingURL=Help.js.map